import axios, { rawAxios } from "../axios";

const API_URL = axios.defaults.baseURL;
const BASE_URL = "/event/";
const DET_URL = "/det-codes"

export const getDETCodeAnalytics = eventID => {
    return axios.get(API_URL + BASE_URL + eventID + DET_URL + "/stats");
};

export const getUploadedDETCode = eventID => {
    return axios.get(API_URL + BASE_URL + eventID + DET_URL);
};

export const getUploadFileURL = (eventID, payload) => {
    return axios.post(
        API_URL + BASE_URL + eventID + DET_URL + "/upload", payload
    );
};

export const uploadDETCodeToS3 = (url, file, mimeType) => {
    const requestConfig = {
        headers: {
            "Content-Type": mimeType,
            "Access-Control-Allow-Origin": "*"
        }
    };
    return rawAxios.put(url, file, requestConfig);
}

export const uploadDETCode = (eventID, payload) => {
    return axios.post(
        API_URL + BASE_URL + eventID + DET_URL, payload
    );
};

export const validateDETCode = (eventID, code) => {
    return axios.get(
        API_URL + BASE_URL + eventID + DET_URL + "/validate?" + `det_code=${code}`
    );
};


